import React from "react";
import "./MenuPage.scss";
import Logo from "../../assets/image/logo/Fathom-Logo.png";
import { SideBarMenu } from "../../assets/data/SideBarMenu";
import { Link } from "react-router-dom";

const MenuPage = () => {
  return (
    <div className="frame-menu-page">
      <div className="frame-logo-left">
        <div className="frame-main-logo-title">
          <div className="frame-image-logo-menu-page">
            <img src={Logo} alt="logo-Fathom-Realty" />
          </div>
          <hr />
          <p>EXPENSES AND BUGET DASHBOARD</p>
        </div>
      </div>

      <div className="frame-menu-right">
        <div className="frame-main-menu-page">
          {SideBarMenu.map((item, index) => (
            <Link
              to={item.link || item.sublink}
              key={index}
              className="frame-item-menu"
            >
              <div className="frame-image-title-menu">
                <img src={item.image} alt={item.name} />
              </div>
              <p>{item.name}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MenuPage;
